<div class="confirm-del-sec">
  <div class="heading">{{heading}}</div>
  <div class="body-font body-text">{{body}}</div>
  <div class="buttons">
    <button class="btn outline-dynamic-color"  (click)="action('no')">Cancel</button>
    <button class="btn filled-dynamic-color" (click)="action('yes')">{{btnText}}</button>
  </div>
</div>
